import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Button, Tooltip } from '..';

import style from './Button.module.scss';


export const OptionsButton = ({
  onSubmit,
  onApprove,
  onCancel,
  onHistory,
  onReject,
  onReturn,
  onCancelReacll,
  onBlockCancel,
  onBlockCancelAndRecall,
  onDelete,
  canSubmit = true,
  onSubmitIcon = 'CHECK',
  onApproveIcon = 'CHECK',
  onCancelIcon = 'CROSS',
  onHistoryIcon = 'HISTORY',
  onRejectIcon = 'REJECT',
  onReturnIcon = 'RETURN',
  onDeleteIcon = 'delete',

  canApprove = true,
  canCancel = true,
  canHistory = true,
  canReject = true,
  canReturn = true,
  canCancelReacll = true,
  canBlockCancel = true,
  canBlockCancelAndRecall = true,
  canDelete = true,
  onSubmitTitle,
  submitDisabled = false,
  onApproveTitle,
  onCancelTitle,
  onHistoryTitle,
  onRejectTitle,
  onReturnTitle,
  onDeleteTitle,
  small
}) => {
  const [ t ] = useTranslation();

  return (
    <div className={ style.optionsButton }>
      { onSubmit && canSubmit && (
        <Tooltip placement="left" title={ onSubmitTitle ?? t('btns.submit') }>
          <div className={ style.option }>
            <Button
              data-testid="submit-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'success' ] }
              disabled={ submitDisabled }
              onClick={ onSubmit }
            >
              <Icon
                svg={ onSubmitIcon }
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>

    )}
      { onApprove && canApprove && (
        <Tooltip placement="left" title={ onApproveTitle ?? t('btns.approve') }>
          <div className={ style.option }>
            <Button
              data-testid="approve-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'success' ] }
              onClick={ onApprove }
            >
              <Icon
                svg={ onApproveIcon }
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>

    )}
      { onHistory && canHistory && (
        <Tooltip placement="left" title={ onHistoryTitle ?? t('btns.history') }>
          <div className={ style.option }>
            <Button
              data-testid="history-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'yellow' ] }
              onClick={ onHistory }
            >
              <Icon
                svg={ onHistoryIcon }
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>

    )}
      { onReject && canReject && (
        <Tooltip placement="left" title={ onRejectTitle ?? t('btns.reject') }>
          <div className={ style.option }>
            <Button
              data-testid="reject-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'danger' ] }
              onClick={ onReject }
            >
              <Icon
                svg={ onRejectIcon }
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>

    )}
      { onReturn && canReturn && (
        <Tooltip placement="left" title={ onReturnTitle ?? t('btns.return') }>
          <div className={ style.option }>
            <Button
              data-testid="return-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'blue' ] }
              onClick={ onReturn }
            >
              <Icon
                svg={ onReturnIcon }
                svgProps={{ width: '30', height: '30' }}
              />
            </Button>
          </div>
        </Tooltip>

    )}
      { onCancelReacll && canCancelReacll && (
        <Tooltip placement="left" title={ onCancelTitle ?? t('btns.recallCancel') }>
          <div className={ style.option }>
            <Button
              data-testid="cancel-recall-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'yellow' ] }
              onClick={ onCancelReacll }
            >
              <Icon
                svg={ onCancelIcon }
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>
    )}
      { onBlockCancel && canBlockCancel && (
        <Tooltip placement="left" title={ onCancelTitle ?? t('btns.cancelBlock') }>
          <div className={ style.option }>
            <Button
              data-testid="block-cancel-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'yellow' ] }
              onClick={ onBlockCancel }
            >
              <Icon
                svg="REJECT"
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>
    )}
      { onBlockCancelAndRecall && canBlockCancelAndRecall && (
        <Tooltip placement="left" title={ onCancelTitle ?? t('btns.cancelAndRecallBlock') }>
          <div className={ style.option }>
            <Button
              data-testid="block-cancel-and-recall-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'yellow' ] }
              onClick={ onBlockCancelAndRecall }
            >
              <Icon
                svg="RETURN"
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>
    )}
      { onCancel && canCancel && (
        <Tooltip placement="left" title={ onCancelTitle ?? t('btns.cancel') }>
          <div className={ style.option }>
            <Button
              data-testid="cancel-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'danger' ] }
              onClick={ onCancel }
            >
              <Icon
                svg={ onCancelIcon }
                svgProps={{ width: '20', height: '20' }}
              />
            </Button>
          </div>
        </Tooltip>
    )}
      { onDelete && canDelete && (
        <Tooltip placement="left" title={ onDeleteTitle ?? t('btns.delete') }>
          <div className={ style.option }>
            <Button
              data-testid="delete-button"
              additions={ [ (small ? 'smallCircle' : 'circle'), 'danger' ] }
              onClick={ onDelete }
            >
              <Icon
                svg={ onDeleteIcon }
                style={{ fontSize: 22 }}
                svgProps={{ width: '22', height: '22' }}
              />
            </Button>
          </div>
        </Tooltip>
    )}
      <div>
        <Button additions={ [ 'primary', 'circle' ] }>
          <Icon
            svg="MENU2"
          />
        </Button>
      </div>
    </div>
  );
};
